import React from "react";

const NotFound = () => <h1>This is not the page you are looking for.</h1>;

export default NotFound;
